(() => {
class HeaderLocalizationPopover extends HTMLElement {
connectedCallback() {
this.details = this.querySelector('details');
this.trigger = this.querySelector('summary');
this.onOutside = e => { if (!this.contains(e.target)) this.details.open = false; };
this.onKey = e => { if (e.key === 'Escape' && this.details.open) { e.preventDefault(); this.details.open = false; this.trigger.focus(); } };
this.onToggle = () => this.trigger.setAttribute('aria-expanded', String(this.details.open));
this.onLanguage = e => {
if (!e.target.matches('.jm-region-form')) return;
const selected = e.submitter;
if (selected?.dataset.language) e.target.querySelector('[name="language_code"]').value = selected.dataset.language;
};
document.addEventListener('click', this.onOutside);
this.addEventListener('keydown', this.onKey);
this.addEventListener('submit', this.onLanguage);
this.details.addEventListener('toggle', this.onToggle);
this.onToggle();
}
disconnectedCallback() {
document.removeEventListener('click', this.onOutside);
this.removeEventListener('keydown', this.onKey);
this.removeEventListener('submit', this.onLanguage);
this.details?.removeEventListener('toggle', this.onToggle);
}
}
if (!customElements.get('header-localization-popover')) customElements.define('header-localization-popover', HeaderLocalizationPopover);
function positionSelector() {
const target = document.querySelector('.announcement-bar-section .localization-wrapper');
const source = document.querySelector('.jinmang-header__desktop-localization');
if (target && source) {
if (source.parentElement !== target) target.append(source);
target.classList.add('jm-top-localization');
target.closest('.utility-bar__grid')?.classList.add('jm-has-top-localization');
}
}
positionSelector();
document.addEventListener('shopify:section:load', positionSelector);
})();
